import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const e = t((r, i) => /* @__PURE__ */ o.jsx(
  c,
  {
    ref: i,
    ...r,
    image: (s) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...s,
        children: [
          /* @__PURE__ */ o.jsx("circle", { cx: 32, cy: 32, r: 32, fill: "#6F5CFF" }),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "#F6F5E9",
              d: "m25.868 13.461-.192-.384c2.785-1.104 5.186-1.44 7.779-1.44 7.682 0 15.413 4.225 15.509 10.323.048 3.36-2.161 5.762-5.378 5.81-9.363.144-7.203-14.549-16.277-14.405-.433 0-1.153.048-1.44.096m18.918 31.642c-4.37.096-14.26-2.88-20.022-18.822-2.017-5.57-3.41-6.866-5.522-6.818-3.217.096-6.29 6.386-6.146 13.06.288 10.036 8.643 19.303 20.455 19.11 9.267-.144 13.78-5.665 14.74-6.914l-.192-.24c-.48.288-1.536.576-3.313.624"
            }
          )
        ]
      }
    )
  }
));
e.displayName = "CurologyLogoStickerIcon";
export {
  e as CurologyLogoStickerIcon,
  e as default
};
//# sourceMappingURL=index.js.map
